import { Button } from '../../components/Button'
import { useNamespacedT } from './useNamespacedT'

// Module level, not inlined below: the usage-vs-bundle i18n test reads `const T = '…'` out of
// each source to resolve the keys that file asks for, and an inlined prefix hides them.
const T = 'c2c_receiving'

// Every action on this screen is the same button, and it was written out four times: without
// the scan permission the endpoint answers 403, so it must not look live; one pipeline runs
// at a time, so all of them lock while any of them runs; only the row being worked on spins;
// and the visible label repeats down the whole list, so the roll code is what tells a
// screen-reader user which package this button belongs to.
export const RowActionButton = ({ order, label, type = 'primary', canScan, busy, busyOrderId = null, dense = true, onClick }) => {
  const t = useNamespacedT(T)
  return (
    <Button
      type={type}
      dense={dense}
      className={dense ? 'px-3' : ''}
      disabled={!canScan || busy}
      loading={busyOrderId === order.id}
      loading_label={t('loading')}
      aria-label={`${label} · ${order.roll_code}`}
      onClick={() => onClick(order)}
    >
      {label}
    </Button>
  )
}
